var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isNotGroup)?_c('span',[_c('icon-status',{attrs:{"estado":this.params.value}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }